import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const filterTypeMap = {
    byUser: "搜索人员",
    byUnit: "搜索科室",
};

const initState = {
    roles: [], // 角色列表
    rolesMap: {}, // 角色对象
    filterType: "byUser",
    searchValue: "",
    unitTreeInitializing: true, // 科室树初始化 - 展开树结构用
    unitTreeLoading: false, // 科室树加载
    units: [], // 科室树
    checkedUnit: { // 选中的科室
        id: null,
        name: "",
        count: null,
    },
    usersLoading: false, // 人员列表加载
    allUsers: [], // 人员列表显示未标记类别前
    users: [], // 人员列表table显示
    nullUserTypeFilter: false, // 仅显示未标记类别人员

    editUser: null, // 编辑人员 -- id判断批量还是单个编辑
    editSaving: false, // 编辑保存
    checkedUsers: [], // 选择的人员列表
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    filterTypeMap,
    update,
    reset,
};
export default viewModel;
